import React from "react";
import PasswordForm from "../PasswordForm";

const ResetPassword = () => {
  return <PasswordForm formHeader="Reset Password" isGotoLogin={true} />;
};

export default ResetPassword;
